import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation();

  if (location.pathname.replace(/\/$/, '') === '/emergencia') {
    return (
      <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md shadow-sm z-50">
        <div className="container mx-auto px-4 lg:px-8 flex items-center justify-between gap-3 min-h-16 py-2">
          <div className="flex items-center gap-2">
            <img src="/images/logo/logo_chaveiro_sem_fundo.webp" alt="Chaveiro Serralheiro" width="40" height="40" className="w-10 h-10 object-contain" />
            <div><span className="block text-lg font-serif font-bold leading-none text-[#0F172A]">CHAVEIRO</span><span className="text-xs tracking-[0.2em] text-[#806600]">SERRALHEIRO</span></div>
          </div>
          <div className="flex gap-2">
            <a href="tel:+351965715768" className="bg-segredo-yellow text-segredo-black px-3 py-3 rounded-sm text-xs font-bold">Ligar agora<span className="hidden sm:inline"> · 965 715 768</span></a>
            <a href="https://wa.me/351965715768" className="bg-[#166534] text-white px-3 py-3 rounded-sm text-xs font-bold">WhatsApp</a>
          </div>
        </div>
      </header>
    );
  }

  const isActive = (path: string) => location.pathname === path;
  const isServicesActive = () => {
    const servicePaths = [
      '/abertura-portas',
      '/mudanca-fechaduras',
      '/reparacao-fechaduras',
      '/instalacao-mola',
      '/trinco-eletricos',
      '/cilindros-porta-blindada',
      '/servicos'
    ];
    return servicePaths.includes(location.pathname);
  };

  const serviceLinks = [
    { path: '/abertura-portas', label: 'Abertura de Portas' },
    { path: '/mudanca-fechaduras', label: 'Troca de Fechaduras' },
    { path: '/reparacao-fechaduras', label: 'Reparação de Fechaduras' },
    { path: '/instalacao-mola', label: 'Instalação Mola Aérea e Chão' },
    { path: '/trinco-eletricos', label: 'Trinco Elétrico' },
    { path: '/cilindros-porta-blindada', label: 'Porta Blindada' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md shadow-sm z-50 transition-all duration-300">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-14">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <div className="relative w-10 h-10 transition-transform duration-300 group-hover:scale-105">
              <div className="absolute inset-0 bg-segredo-yellow rounded-full blur-md opacity-20 group-hover:opacity-40 transition-opacity"></div>
              <img
                src="/images/logo/logo_chaveiro_sem_fundo.webp"
                alt="Chaveiro Serralheiro" width="40" height="40"
                className="w-full h-full object-contain relative z-10"
              />
            </div>
            <div className="flex flex-col">
              <span className="text-lg font-serif font-bold tracking-tight text-[#0F172A] leading-none">
                CHAVEIRO
              </span>
              <span className="text-sm font-sans font-medium tracking-[0.2em] text-[#806600] uppercase">
                SERRALHEIRO
              </span>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-10">
            <Link
              to="/"
              className={`text-xs font-bold tracking-widest uppercase transition-colors cursor-pointer whitespace-nowrap ${isActive('/') ? 'text-[#806600]' : 'text-gray-800 hover:text-[#806600]'
                }`}
            >
              Home
            </Link>

            {/* Dropdown de Serviços */}
            <div className="relative group">
              <button
                className={`flex items-center gap-1 text-xs font-bold tracking-widest uppercase transition-colors cursor-pointer whitespace-nowrap ${isServicesActive() ? 'text-[#806600]' : 'text-gray-800 hover:text-[#806600]'
                  }`}
              >
                Serviços <i className="ri-arrow-down-s-line transition-transform group-hover:rotate-180"></i>
              </button>

              <div className="absolute top-full left-0 w-72 bg-white shadow-xl rounded-sm py-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform translate-y-4 group-hover:translate-y-0 border-t-4 border-segredo-yellow">

                {serviceLinks.map((service) => (
                  <Link
                    key={service.path}
                    to={service.path}
                    className={`block px-6 py-3 text-sm hover:bg-gray-50 hover:text-[#806600] transition-colors font-medium border-b border-gray-50 last:border-0 ${isActive(service.path) ? 'text-[#806600] bg-gray-50' : 'text-gray-600'
                      }`}
                  >
                    {service.label}
                  </Link>
                ))}
              </div>
            </div>



            <Link
              to="/blog"
              className={`text-xs font-bold tracking-widest uppercase transition-colors cursor-pointer whitespace-nowrap ${isActive('/blog') ? 'text-[#806600]' : 'text-gray-800 hover:text-[#806600]'
                }`}
            >
              Blog
            </Link>

            <Link
              to="/sobre"
              className={`text-xs font-bold tracking-widest uppercase transition-colors cursor-pointer whitespace-nowrap ${isActive('/sobre') ? 'text-[#806600]' : 'text-gray-800 hover:text-[#806600]'
                }`}
            >
              Sobre nós
            </Link>
            <Link
              to="/contato"
              className={`text-xs font-bold tracking-widest uppercase transition-colors cursor-pointer whitespace-nowrap ${isActive('/contato') ? 'text-[#806600]' : 'text-gray-800 hover:text-[#806600]'
                }`}
            >
              Contactos
            </Link>
          </nav>

          <div className="hidden lg:flex items-center gap-4">
            <a
              href="tel:+351965715768"
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2 bg-segredo-yellow text-segredo-black rounded-full font-bold uppercase text-xs tracking-widest hover:bg-segredo-yellow-hover transition-all cursor-pointer whitespace-nowrap shadow-md hover:shadow-lg hover:-translate-y-0.5 flex items-center gap-2"
            >
              <i className="ri-phone-line text-lg"></i>
              965 715 768
            </a>
          </div>

          <button
            aria-label={isMenuOpen ? "Fechar menu" : "Abrir menu"}
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden w-12 h-12 flex items-center justify-center text-gray-700 cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="lg:hidden bg-white/95 backdrop-blur-md border-t border-gray-100 max-h-[calc(100vh-56px)] overflow-y-auto">
          <nav className="container mx-auto px-6 py-6 flex flex-col gap-2">
            <Link to="/" className="py-3 px-4 text-gray-800 hover:text-[#806600] cursor-pointer hover:bg-gray-50 rounded-sm font-bold uppercase tracking-widest text-xs" onClick={() => setIsMenuOpen(false)}>
              Home
            </Link>

            {/* Mobile Services Accordion */}
            <div className="py-2">
              <button
                onClick={() => setIsServicesOpen(!isServicesOpen)}
                className="flex items-center justify-between w-full py-3 px-4 text-gray-800 hover:text-[#806600] cursor-pointer font-bold uppercase tracking-widest text-xs"
              >
                <span>Serviços</span>
                <i className={`ri-arrow-down-s-line transition-transform ${isServicesOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {isServicesOpen && (
                <div className="pl-6 mt-2 flex flex-col gap-1 border-l-2 border-segredo-yellow ml-4">

                  {serviceLinks.map((service) => (
                    <Link
                      key={service.path}
                      to={service.path}
                      className="py-3 px-4 text-xs text-gray-600 hover:text-[#806600] hover:bg-gray-50 rounded-sm uppercase tracking-wide"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {service.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>



            <Link to="/sobre" className="py-3 px-4 text-gray-800 hover:text-[#806600] cursor-pointer hover:bg-gray-50 rounded-sm font-bold uppercase tracking-widest text-xs" onClick={() => setIsMenuOpen(false)}>
              Sobre nós
            </Link>
            <Link to="/contato" className="py-3 px-4 text-gray-800 hover:text-[#806600] cursor-pointer hover:bg-gray-50 rounded-sm font-bold uppercase tracking-widest text-xs" onClick={() => setIsMenuOpen(false)}>
              Contactos
            </Link>
            <a
              href="tel:+351965715768"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 px-5 py-4 bg-segredo-yellow text-segredo-black rounded-sm font-bold uppercase tracking-widest text-xs text-center cursor-pointer whitespace-nowrap shadow-md"
            >
              Ligar Agora
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
